export const accessPolicies = {
    EnableZIVVWithdrawalPlanChange: 'EnableZIVVWithdrawalPlanChange',
    EnableZIFDWithdrawalPlanChange: 'EnableZIFDWithdrawalPlanChange',
    EnableBeneficiaryChange: 'EnableBeneficiaryChange',
    EnableDocumentSigning: 'EnableDocumentSigning',
    CompleteFollowUpInvestorProfileApplication: 'CompleteFollowUpInvestorProfileApplication',
    SubmitApplicationWithUploadedAdvisory: 'SubmitApplicationWithUploadedAdvisory',
    Reports: 'Reports',
};
